import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SsoUserAttributeTypeDto } from '../interfaces/sso-user-attribute-type-dto';
import { envToken } from '../tokens/env-token';

@Injectable({
    providedIn: 'root'
})
export class SsoUserAttributeTypeService {
    private readonly http = inject(HttpClient);
    private env = inject(envToken);

    private readonly baseUrl = this.env.apiUrl + '/api/v1/sso-user-attribute-type';

    getIdpAttributes(): Observable<SsoUserAttributeTypeDto[]> {
        return this.http.get<SsoUserAttributeTypeDto[]>(`${this.baseUrl}/idp`);
    }
}
